"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveTaxVatNumber = exports.saveMyData = exports.refreshToken = exports.getTaxVatNumbers = exports.getPersonalData = exports.getMyData = exports.getBusinessPartner = exports.default = void 0;
var _myDataApi = _interopRequireDefault(require("../csc/api/myDataApi"));
var _myDataApi2 = _interopRequireDefault(require("../cic/api/myDataApi"));
var _mainConfig = require("../mainConfig");
var currentApiSet = _mainConfig.isCICContentTree ? _myDataApi2.default : _myDataApi.default;
var saveMyData = exports.saveMyData = currentApiSet.saveMyData,
  getTaxVatNumbers = exports.getTaxVatNumbers = currentApiSet.getTaxVatNumbers,
  saveTaxVatNumber = exports.saveTaxVatNumber = currentApiSet.saveTaxVatNumber,
  getPersonalData = exports.getPersonalData = currentApiSet.getPersonalData,
  refreshToken = exports.refreshToken = currentApiSet.refreshToken,
  getBusinessPartner = exports.getBusinessPartner = currentApiSet.getBusinessPartner,
  getMyData = exports.getMyData = currentApiSet.getMyData;
var _default = exports.default = currentApiSet;